import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-de4ddd32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tree-box el-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RepairItemTree = _resolveComponent("RepairItemTree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RepairItemTree, {
      "repair-type": _ctx.HandleType.AUTO,
      "update-change": _ctx.updateTreeChange
    }, null, 8, ["repair-type", "update-change"]),
    _createVNode(_component_RepairItemTree, {
      "repair-type": _ctx.HandleType.NOTIFY,
      "update-change": _ctx.updateTreeChange
    }, null, 8, ["repair-type", "update-change"]),
    _createVNode(_component_RepairItemTree, {
      "repair-type": _ctx.HandleType.IGNORE,
      "update-change": _ctx.updateTreeChange
    }, null, 8, ["repair-type", "update-change"])
  ]))
}